import { RefObject, useCallback, useLayoutEffect } from 'react';

interface UseAutoGrowTextareaOptions {
    maxHeight: number;
    lineHeight: string;
}

/**
 * Автоматически подгоняет высоту textarea под содержимое — до maxHeight.
 */
export const useAutoGrowTextarea = (
    ref: RefObject<HTMLTextAreaElement | null>,
    value: string,
    { maxHeight, lineHeight }: UseAutoGrowTextareaOptions,
) => {
    const adjust = useCallback(() => {
        const el = ref.current;
        if (!el) return;
        // сначала сжимаем до 1 строки — чтобы scrollHeight отразил реальную высоту контента,
        // а не текущую выставленную. Без этого высота не уменьшается при удалении текста
        el.style.height = lineHeight;
        el.style.height = `${Math.min(el.scrollHeight, maxHeight)}px`;
        el.style.overflowY = el.scrollHeight > maxHeight ? 'auto' : 'hidden';
    }, [ref, maxHeight, lineHeight]);

    useLayoutEffect(() => {
        adjust();
    }, [value, adjust]);

    return { adjust };
};
